import enLocale from 'element-ui/lib/locale/lang/en';
import countries from './en/countries';

export default {
  test: 'Test EN',
  search: 'Search...',
  backend: {
    errors: {
      40003: 'You don\'t have access to that section',
      41012: 'Allowed devices limit was reached',
      41015: 'Provided password is incorrect',
      41017: 'Invalid phone number prefix',
      41018: 'Account Name is required',
      42000: 'Email is incorrect',
      42004: 'User already exist',
      42005: 'Login or password is incorrect',
      42010: 'Invalid or used password reset link',
      42016: 'Invalid token',
      42019: 'Invalid password',
      43000: 'Device already registered',
      44000: 'Wrong phone number format',
      45000: 'Contact does not exist',
    },
    general: {
      userNotExist: 'User with provided credentials doesn\'t exist',
      wrongUserPass: 'Username or password incorrect',
    },
  },
  general: {
    close: 'Close',
    yes: 'Yes',
    no: 'No',
    actions: 'Actions',
    save: 'Save',
    accountNotConfirmed: `Your account is not confirmed - click on the link sent to your e-mail address to confirm it.
      If not, then 30 days after registration account will be suspended`,
    goToSettings: 'Go to settings',
    sendMailAgain: 'Send mail again',
    mailSent: 'Mail sent - check your inbox',
    confirmYourAccount: 'Confirm your account',
    personalDataNotFilled: `Please fill your personal data connected with account -
      it is important for creating correct invoice`,
    fillPersonalData: 'Fill personal data',
    clickToCopy: 'Click to copy the value',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
    refreshData: 'Refresh data',
    subscriptionNearEnd: 'Your subscription will end soon - check Payments tab for more info',
    subscriptionEnded: 'Your subscription expired. You cannot use application until you extend your plan.',
  },
  menu: {
    dashboard: 'Dashboard',
    billing: 'Billing informations',
    suggestions: 'Suggestions',
    settings: 'Settings',
    contact: 'Contact',
    devices: 'Devices',
    apiKeys: 'API keys',
    logout: 'Logout',
    integrations: 'Integrations',
    profile: 'User profile',
    plan: 'Plan',
    callHistory: 'Call history',
    properties: 'Properties',
    records: 'Search Contact',
    paymentSettings: 'Payment settings',
    invoices: 'Invoices',
    help: 'Help',
  },
  forms: {
    required: 'This field is required',
    wrongPhone: 'Wrong phone number',
    wrongUrl: 'Invalid url format (valid for example https://labelcall.com)',
    missingField: 'Missing value for field \'{field}\'',
    phone: 'Phone number',
    acceptTerms: 'You have to accept required terms to continue',
    options: {
      langs: countries,
      currencies: {
        PLN: 'Polish zloty (PLN)',
        EUR: 'Euro (EUR)',
        USD: 'US Dollars (USD)',
        GBP: 'Great Britain pounds (GBP)',
      },
      currenciesSuffix: {
        PLN: 'zł',
        EUR: '€',
        USD: '$',
        GBP: '£',
      },
    },
    error: 'Error: {msg}',
    invalidEmail: 'Provide e-mail with valid format',
    optional: '(optional)',
    passwordsNotMatch: 'Passwords do not match',
    passwordPolicy: 'The password should be at least 8 characters, contain uppercase and lowercase letters, a number and a special character',
    invalidUserNameOrPassword: 'Invalid e-mail or password',
  },
  login: {
    title: 'Login to the Labelcall',
    email: 'E-mail address',
    password: 'Password',
    login: 'Login',
    forgotPassword: 'Forgot password',
    dontHaveAccount: 'Don\'t have an account?',
    register: 'Register here',
  },
  register: {
    success: 'Account created sucessfully',
    title: 'To register please fill the form below',
    accountType: {
      personal: 'Personal account',
      business: 'Business account',
    },
    email: 'E-mail address',
    password: 'Password',
    phone: 'Phone number',
    locale: 'Language',
    repeatPassword: 'Repeat password',
    backToLogin: 'Back to login',
    register: 'Register',
    confirmPassword: 'Confirm password',
    termsOfService1: 'I agree to Labelcall\'s',
    marketingConsent: "I agree to the processing of my personal data by Labelcall for the purposes of order processing and marketing",
    newsletterConsent: "I agree to receive the Newsletter on submitted e-mail address",
  },
  logout: {
    success: 'User logged out successfully',
  },
  languagePicker: {
    pl: 'Polski',
    en: 'English',
  },
  profileDropdown: {
    myProfile: 'My profile',
    logout: 'Logout',
    licenseDaysLeft: '{daysLeft} days left to license end',
  },
  typePicker: {
    line: 'Line chart',
    pie: 'Pie chart',
    bar: 'Bar chart',
    table: 'Data table',
  },
  datePicker: {
    startDate: 'Start date',
    endDate: 'End date',
    lastWeek: 'Last 7 days',
    lastTwoWeeks: 'Last 14 days',
    lastSmallMonth: 'Last 28 days',
    lastMonth: 'Last 30 days',
    lastThreeMonths: 'Last 3 months',
    lastSixMonths: 'Last 6 months',
    lastYear: 'Last year',
  },
  chart: {
    noData: 'No data for chart',
    refresh: 'Refresh chart',
  },
  billing: {
    title: 'Billing data',
    name: 'Name',
    vatnr: 'VAT number',
    phone: 'Phone number',
    address: 'Address',
    postcode: 'Postcode',
    city: 'City',
    country: 'Country',
    success: 'Billing data updated successfully',
    firstName: 'First name',
    lastName: 'Last name',
  },
  settings: {
    title: 'Settings',
    changePasswordTitle: 'Change password',
    changePassword: 'Change password',
    oldPassword: 'Current password',
    password: 'New password',
    repeatPassword: 'Repeat new password',
    changePasswordSuccess: 'Password changed successfully',
    general: 'General',
    currency: 'Base currency',
    changeSuccess: 'Data changed successfully',
  },
  resetPassword: {
    title: 'Please provide your e-mail address to send a reset password link',
    backToLogin: 'Back to login',
    success:
      'We sent you an e-mail with password reset link - check your inbox',
    label: 'Send',
    email: 'E-mail address',
    failure: 'Error during password reset process, please try again',
    failureMsg: 'Error during password reset process: {msg}',
  },
  setNewPassword: {
    title: 'Provide new password',
    backToLogin: 'Back to login',
    success: 'Password changed successfully',
    password: 'New password',
    confirmPassword: 'Repeat new password',
    label: 'Change password',
    failure: 'Error during password reset process, please try again',
    failureMsg: 'Error during password reset process: {msg}',
  },
  selectAccount: {
    title: 'Please provide customer e-mail address',
    backToAccount: 'Go to your account',
    success: 'The account has been changed',
    label: 'Login',
    email: 'E-mail address',
    failure: 'Error during login to customer account, please try again',
    failureMsg: 'Error during login to customer account: {msg}',
  },
  dashboard: {
    title: 'Dashboard',
    paymentMethods: 'Used payment methods',
    shippingMethods: 'Used shipping methods',
    sessions: 'Sessions',
    users: 'Users',
    transactionsCount: 'Transactions number',
    failedTransactionCount: 'Failed',
    successTransactionCount: 'Success',
    transactionsIncome: 'Transactions income',
    transactionsLost: 'Transactions lost',
    averageCartValue: 'Average cart value',
    chart: {
      total: 'Total',
    },
  },
  devices: {
    title: 'Devices',
    addNew: 'Add new device',
    phoneNumber: 'Phone number',
    name: 'Name',
    email: 'Email',
    deviceStatus: 'Status',
    deviceGroupList: 'Device group',
    active: 'Active',
    inactive: 'Inactive',
    activate: 'Activate',
    pending: 'Pending',
    disable: 'Disable',
    changeStatusSuccess: 'The device status has been changed successfully',
    delete: 'Delete',
    deleteSuccess: 'Device removed successfully',
    deleteText: 'This operation is irreversible! Do you want to continue?',
    deleteTitle: 'Confirm removal {email}',
    add: {
      title: 'Add new device',
      phoneNumber: 'Phone number',
      name: 'Name',
      deviceGroups: 'Device group',
      deviceGroupsAdd: 'Enter the group ID and press ENTER',
      success: 'Device added successfully',
      email: 'Email',
    },
    summaryTitle: 'Devices in subscription:',
  },
  contact: {
    title: 'Contact',
    send: 'Send',
    subject: 'Subject',
    message: 'Message',
    sendSuccess: 'Thank you for contacting us - we will get back to you as soon as possible',
  },
  apiKeys: {
    title: 'API keys',
    addNew: 'Generate new key',
    id: 'ID',
    scope: 'Permission group',
    created: 'Created',
    apiKey: 'API key',
    documentationLink: 'API documentation',
    deleteText: 'This operation is irreversible! Do you want to continue?',
    deleteTitle: 'Confirm API Key removal',
    deleteSuccess: 'API key removed successfully',
    apiKeyBelow: 'Below you can find your API key',
    copyInfo: 'copy it and keep it safe, because you won\'t be able to view it again later!',
    keyGeneratedTitle: 'API key generated',
    masterAccountId: 'MasterAccountId',
  },
  wizard: {
    account: {
      name: 'Your name',
      phoneNumber: 'Phone number',
      email: 'E-mail address',
      domain: 'Domain name',
      lang: 'Language',
      password: 'Password',
      passwordInfo: 'To link your existing Labelcall account to the new integration, enter your password',
    },
    props: {
      title: 'Properties',
      description: 'Choose what information you want to display on the phone when the customer is calling. You can also freely set their order by dragging the beams',
    },
    next: 'Next',
    previous: 'Previous',
    title: 'Complete the data.',
    step: 'Step',
    accountSettings: 'Account Settings',
    propSettings: 'Properties Configuration',
    integrationAlreadyExists: 'Integration already exists',
    createIntegrationError: 'We could not create integration. Try again later',
    invalidPassword: 'Password incorrect',
    summary: 'Summary',
    registrationSuccessful: 'Registration successful!',
    thanks: 'Thank you!',
    appDownloadHeader: 'Now, you can download our app on your mobile phone.',
    appDownload: 'Use the link below or use the link we sent via SMS to your phone.',
    syncInProgress: 'Do you want to try the app?',
    syncCompleted: 'Data synchronization completed',
    syncAboutToStart: 'Data synchronization is about to start',
    end: 'Finish',
    loginToPortal: 'Login to portal',
    alreadyHaveAaAccount: 'Already have an account?',
    loginHere: 'Log in here',
    dontHaveAccount: 'Don\'t have account?',
    registerHere: 'Register here',
    forgotPassword: 'I forgot my password',
    resetPassword: 'Reset Password',
    summaryGetMobileApp1: 'Use the link below to download the app on your phone. Then connect to your account and you are ready to use. If you have any problem grab our',
    summaryGetMobileApp2: 'manual',
    summaryGetMobileApp3: 'or contact us on',
    summaryPassword: 'An admin panel password has been sent to an email address provided earlier.',
    summaryContact: 'If you have any problem contact us on',
    summarySynchronization1: 'We are now synchronizing your historical data to Labelcall service, it may take even an hour.',
    summarySynchronization2: 'New clients are syncing immediately.',
    integrationLogo: 'Integration logo',
    terms1: 'By clicking "Next" I agree Labelcall\'s',
    terms2: 'Terms & Conditions',
    terms3: 'and',
    terms4: 'Privacy Policy',
    erecruiterInvalidAccessKey: 'ERecruiter invalid access key',
    erecruiterAccessKeyUpdated: 'ERecruiter access key updated successfully',
    erecruiterAccountWithCompanyIdAlreadyExists: 'This ERekruter account is already linked to an existing Labelcall account',
    traffitInvalidCredentials: 'Invalid Traffit credentials',
    traffitCredentialsUpdated: 'Traffit credentials updated successfully',
    traffitAccountAlreadyExists: 'This Traffit tenant is already linked to an existing Labelcall account',
    traffitConfig: 'Traffit configuration',
    traffitDescription: 'Enter your Traffit API credentials. You can find them in Traffit Settings > Integration.',
    apiloInvalidCredentials: "Invalid Apilo crendtials",
    apiloDescription: "The following data is needed for communication with Apilo",
    apiloConfig: "Apilo configuration ",
    apikeys: {
      header: 'API Keys',
      description: 'The API key is needed to communicate with the service to download data.',
      descriptionLink: 'For more information, visit the website.',
      url: 'Url',
      apiKey: 'API Key',
      invalidApiKey: 'Invalid API key'
    },
  },
  calls: {
    history: 'Call history',
    phoneNumber: 'Phone number',
    callType: 'Type of call',
    dateTimeOfCall: 'Date',
    callDuration: 'Duration',
    callStatus: 'Status',
    incoming: 'incoming',
    outgoing: 'outgoing',
    received: 'received',
    rejected: 'rejected',
    callsCount: 'Calls count:',
    lastCall: 'Last call:',
    totalDuration: 'Todal calls duration:',
    chartSummary: 'Calls duration',
    wasRecognized: 'Was recognized?',
    true: 'yes',
    false: 'no',
  },
  payments: {
    history: 'Payment history',
    subscriptionCode: 'Subscription Code',
    allowedDevices: 'Allowed devices',
    allowedCallsMonthly: 'Allowed calls per month',
    allowedCallsDaily: 'Allowed identified calls per day',
    allowedCallsDailyUnlimited: 'Unlimited',
    amount: 'Price',
    status: 'Status',
    date: 'Date',
    refreshTable: 'Refresh table',
    action: 'Action',
    buy: 'Buy',
    extend: 'Extend',
    unlimitedCallsMonthly: 'Unlimited',
    payment: {
      saveBillingInformations: 'Save billing information',
      creditOrDebitCard: 'Credit or Debit Card',
      pay: 'Pay',
      success: 'Payment successful, thank you!',
      addNewCard: 'Add new card',
      selectCard: 'Select card',
      selectCardError: 'Select card or add a new card',
      error: 'Payment has failed, try again later',
      shopifyInfo: 'Payment will be made through Shopify.',
      goToShopify: 'Go to Shopify',
      shopifyRemovedIntegrationInfo: 'Your Labelcall account is no longer linked with Shopify through marketplace integration. Please go to Shopify to link the app again.',
    },
  },
  integrations: {
    title: 'Integrations',
    type: 'Type',
    domain: 'Domain',
    status: 'Status',
    refreshTable: 'Refresh table',
    action: 'Action',
    details: 'Details',
    dataLoadError: 'Error while loading data, try again later',
    name: 'Name',
    changeName: 'Change name',
    addNextIntegration: 'Add another integration',
    deleteSuccess: 'Integration removed!',
    updateSuccess: 'Integration updated!',
    activateSuccess: 'Integration activated!',
    error: 'Error occured!',
    deleteTitle: 'Confirm integration removal',
    integration: {
      title: 'Integration',
      domain: 'Domain',
      type: 'Type',
      apikey: 'API key',
      status: 'Status',
      manualsync: 'Manual synchronization',
      sync: 'Synchronize',
      props: 'Properties',
      save: 'Save',
      back: 'Back',
      syncStarted: 'Synchronization started',
      syncError: 'Synchronization failed, try again later',
      propsUpdatedSuccess: 'Properties updated successfuly',
      propsUpdatedError: 'Properties update failed, try again later',
      externalRemove: 'It is not possible to remove the integration from the admin panel, remove the integration on: ',
      connect: 'Connect again',
    },
    delete: 'Delete',
    activate: 'Activate',
    statuses: {
      active: 'Active',
      notcomplete: 'Not Complete',
      suspended: 'Suspended',
      deleted: 'Deleted',
      turnoff: 'Turn Off',
      expired: 'Expired'
    }    
  },
  profile: {
    title: 'User profile',
    passwordChange: 'Change password',
    email: 'Email',
    name: 'Name',
    accountName: 'Account Name',
    language: 'Language',
    current_password: 'Current password',
    new_password: 'New password',
    new_password_confirm: 'Confirm new password',
    profileUpdateSuccess: 'Profile updated successfully',
    passwordChangeSuccess: 'Password changed successfully',
    defaultPhoneNumberPrefix: 'Phone Prefix',
  },
  plan: {
    yourSubTitle: 'Your subscription',
    currentSubscription1: 'Your current subscription is ',
    currentSubscription2: ' and it\'s ending ',
    noSubscription: 'You don\'t own any subscription',
    title: 'Subscription plans',
    plans: {
      lc_basic: 'Basic',
      lc_advance: 'Advanced',
      lc_premium: 'Premium',
      lc_basic_yearly: 'Basic',
      lc_advance_yearly: 'Advanced',
      lc_premium_yearly: 'Premium',
      free10: 'Freemium',
    },
    allowedDevicesUnlimited: 'Unlimited number of devices',
    allowedCallsDailyUnlimited: 'Unlimited identified calls ',
    allowedContactsUnlimited: 'Unlimited number of contacts',
    allowedDevices: '{n} device | {n} devices',
    allowedCallsDaily: '{n} identified calls per day',
    allowedCallsMonthly: '{n} identified calls per month',
    allowedContacts: '{n} contacts',
    responseTimeGuarantee: 'Response time guarantee',
    labelcallApiAccess: 'Access to API Labelcall',
    buy: 'Buy now',
    perMonth: 'per month',
    perYear: 'per year',
    writeToUs: 'Write to us at contact@labelcall.com',
    individualOffer: 'Personalized offer',
    cancelSubscription: 'Downgrade to free',
    cancel: 'Cancel',
    cancelSubMsg: 'If the subscription is canceled, it will not be renewed at the end of its term. This operation is irreversible!',
    subscriptionCancelSuccess: 'Subscription canceled successfully',
    subscriptionCancelError: 'Subscription canceled failed, try again later',
    subCancalled: 'Subscription cancalled',
    free: 'Free',
    changingSubscription: 'Subscription is being changed...',
    shopifyInformation: 'and it\'s handled by Shopify. For more information, go to your Shopify dashboard.',
    showYearlyDuration: 'Show yearly subscriptions',
    changePlanWarining: 'Changing the plan may deactivate devices.',
  },
  properties: {
    noProps: 'No properties available - create integration to add some',
    propertyOrigin: 'Property origin',
    origin: {
      custom: 'custom',
    },
    propsUpdatedSuccess: 'Properties updated successfuly',
    propsUpdatedError: 'Properties update failed, try again later',
    isActive: 'Is field active',
    selectSource: 'Select source',
  },
  paymentSettings: {
    title: 'Payment settings',
    addNew: 'Add new card',
    brand: 'Brand',
    last4: 'Card number',
    setAsDefault: 'Set as default',
    delete: 'Delete',
    expDate: 'Expire date',
    default: 'Default',
    deleteCardMsg: 'This operation is irreversible! Do you want to continue?',
    cancel: 'Cancel',
    deleteCard: 'Delete card',
    cardDeleteSuccess: 'Card removed successfully',
    cardDeleteError: 'Card removal failed, try again later',
    tableDataLoadingError: 'Downloading list of card failed, try again later',
    cardSetAsDefaultSuccess: 'Setting card as default successful',
    cardSetAsDefaultError: 'Setting card as default failed, try again later',
    addCard: 'Add card',
    addCardSuccess: 'Card added successfully',
    addCardError: 'Failed to add card, try again later',
    cannotDeleteDefaultCard: 'The default card cannot be removed if subscription is active',
  },
  invoices: {
    history: 'Payment history',
    subscriptionCode: 'Subscription Code',
    amount: 'Price',
    status: 'Status',
    date: 'Date',
    refreshTable: 'Refresh table',
    invoicePdf: 'Invoice PDF',
    downloadPdf: 'Download',
  },
  searchContact: {
    title: 'Search Contact',
    search: 'Search',
    noRecord: 'No contact',
    propertyName: 'Property Name',
    value: 'Value',
    phoneNumber: 'Phone number',
    or: 'Or',
    source: 'Source',
    open: 'Open',
    dateCreated: 'Date created',
    dateModified: 'Date modified',
    chooseIntegration: 'Choose Integration',
  },
  stepTracker:{
    installApp: "1. Install mobile app",
    appInstalled: "1. Mobile app installed",
    installAppContent: "Download the app on your phone to be able to connect to your platform",
    appInstalledContent: "You are on the right track! Now all you have to do is connect to your platform",
    integrateShop: "2. Connect to your shop",
    shopIntegrated: "2. Shop connected",
    integrateShopContent: "In the \"Integration\" tab, integrate with your platform. You can also do it from your phone.",
    shopIntegratedContent: "Way to go! You can now fully use our app :-)",
    button: "Integrations"
  },
  ...enLocale,
};
